import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonLatestNews = () => {
    return (
        <div className="skeleton-latest-news-wrapper xmt-20">
            <div className="container">
                <div className="header-news">
                    <div className="d-flex justify-content-end"><IconName name="chevron_left" className="icon"/></div>
                    <div className="border-slider position-relative xmt-2">
                        <div className="active-border position-absolute"></div>
                    </div>
                </div>

                <div className="slider-wrapper xmt-6 d-flex align-items-center">
                    <div className="slider skeleton-loading br-4">
                        <div className="image-sk skeleton-loading"></div>
                        <div className="body-card xpx-4">
                            <div className="text-sk text--1 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--2 skeleton-loading xmt-2"></div>
                            <div className="text-sk text--3 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--4 skeleton-loading xmt-2"></div>
                            <div className="profile-sk skeleton-loading xmt-14"></div>
                        </div>
                    </div>
                    <div className="slider skeleton-loading br-4 xmr-6">
                        <div className="image-sk skeleton-loading"></div>
                        <div className="body-card xpx-4">
                            <div className="text-sk text--1 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--2 skeleton-loading xmt-2"></div>
                            <div className="text-sk text--3 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--4 skeleton-loading xmt-2"></div>
                            <div className="profile-sk skeleton-loading xmt-14"></div>
                        </div>
                    </div>
                    <div className="slider skeleton-loading br-4 xmr-6">
                        <div className="image-sk skeleton-loading"></div>
                        <div className="body-card xpx-4">
                            <div className="text-sk text--1 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--2 skeleton-loading xmt-2"></div>
                            <div className="text-sk text--3 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--4 skeleton-loading xmt-2"></div>
                            <div className="profile-sk skeleton-loading xmt-14"></div>
                        </div>
                    </div>
                    <div className="slider skeleton-loading br-4 xmr-6">
                        <div className="image-sk skeleton-loading"></div>
                        <div className="body-card xpx-4">
                            <div className="text-sk text--1 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--2 skeleton-loading xmt-2"></div>
                            <div className="text-sk text--3 skeleton-loading xmt-4"></div>
                            <div className="text-sk text--4 skeleton-loading xmt-2"></div>
                            <div className="profile-sk skeleton-loading xmt-14"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonLatestNews;
